export var SectionType;
(function (SectionType) {
    SectionType["ad"] = "ad";
    SectionType["bottomSpacer"] = "bottomSpacer";
    SectionType["button"] = "button";
    SectionType["divider"] = "divider";
    SectionType["follow"] = "follow";
    SectionType["footer"] = "footer";
    SectionType["html"] = "html";
    SectionType["image"] = "image";
    SectionType["link"] = "link";
    SectionType["logo"] = "logo";
    SectionType["mix"] = "mix";
    SectionType["music"] = "music";
    SectionType["placeholder"] = "placeholder";
    SectionType["itemGrid"] = "item_grid";
    SectionType["subscribe"] = "subscribe";
    SectionType["text"] = "text";
    SectionType["topSpacer"] = "topSpacer";
    SectionType["video"] = "video";
    SectionType["wixFooter"] = "wix_footer";
})(SectionType || (SectionType = {}));
export var ButtonAlign;
(function (ButtonAlign) {
    ButtonAlign["center"] = "center";
    ButtonAlign["left"] = "left";
    ButtonAlign["right"] = "right";
})(ButtonAlign || (ButtonAlign = {}));
//# sourceMappingURL=types.js.map